//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import mpi from "@/plugins/merge";

export default {
  name: "SaveDrawer",
  props: {
    info: {
      type: Object,
      default() {
        return {}
      }
    },
    engraving: {
      type: Object,
      default() {
        return {}
      }
    },
    views: {
      type: Array,
      default() {
        return []
      }
    },
    drawer: {
      type: Boolean,
      default: false
    },
    fonts: {
      type: Array,
      default() {
        return []
      }
    },
    mt: {
      type: String,
    },
    showEngravingPlaceholder: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // products: this.info.request_config || [],
      loading: false,
      openIndex: -1,
      emailSuccess: false,
      confirmMessage: null,
      confirmErrMessage: null,
      email: '',
      saveModal: false,
      loadingSave: false,
      w: 0,
      productImg: null,
    }
  },
  methods: {
    async createProductImg() {
      mpi.init();
      if(document.querySelector('#product-container')) {
        this.productImg = await mpi.getMergedImage('#product-container', true);
      }
    },
    // setBoxText() {
    //   const canvas = document.querySelectorAll("#canvasBoxSave");
    //   canvas.forEach(item => {
    //     let ctx = item.getContext("2d");
    //     ctx.clearRect(0, 0, item.width, item.height);
    //     ctx.font = `700 60px Helvetica`;
    //     ctx.fillStyle = "darkgoldenrod";
    //     ctx.textAlign = "center";
    //     ctx.fillText(this.$route.query.bt ? this.$route.query.bt.toUpperCase() : '',
    //       item.width / 2 - 28,
    //       item.height / 2 + 60);
    //   })
    // },
    // sortImages(images) {
    //   const imagesN = {}
    //   for (const k in images) {
    //     let a = k.replace(/^\D+/g, '');
    //     a = Number(a);
    //     imagesN[a] = images[k]
    //   }
    //   const sorted = Object.keys(imagesN).sort().reduce(
    //     (obj, key) => {
    //       obj[key] = imagesN[key];
    //       return obj;
    //     },
    //     {}
    //   );
    //   const arr = [];
    //   for (const i in sorted) {
    //     arr.push(sorted[i])
    //   }
    //   return arr
    // },
    async createImage() {
      // mpi.init();
      // let top = this.info.theme.id === this.constProductThemes().package ? 38 : 4;
      // switch (this.info.vendor_model.toLowerCase()) {
      //   case 'sorguno':
      //     top = -8;
      //     break;
      //   case 'sorgunocabo':
      //     top = -8;
      //     break;
      //   case 'sorgcabo':
      //     top = -8;
      //     break;
      //   case 'sorgcore':
      //     top = -8;
      //     break;
      //   case 'sorgduo':
      //     top = -8;
      //     break;
      //   case 'sorgmst':
      //     top = -8;
      //     break;
      //   case 'sorgbrand':
      //     top = -8;
      //     break;
      //   case 'sobrcabo':
      //     top = -8;
      //     break;
      //   case 'sobrduo':
      //     top = -8;
      //     break;
      //   case 'sobrmst':
      //     top = -8;
      //     break;
      //   case 'orbring':
      //     top = -8;
      //     break;
      //   case 'pavedomeband':
      //     top = -8;
      //     break;
      //   case 'thinpavedomeband':
      //     top = -8;
      //     break;
      //   case 'columnring':
      //     top = -8;
      //     break;
      //   case 'sonlsgchn':
      //     top = -3;
      //     break;
      // }

      const imgBase64 = await mpi.getMergedImage('.save-des-images', true);

      function DataURIToBlob(dataURI) {
        const splitDataURI = dataURI.split(',');
        const byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1]);
        const mimeString = splitDataURI[0].split(':')[1].split(';')[0];
        const ia = new Uint8Array(byteString.length);
        for (let i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ia], {type: mimeString});
      }

      return DataURIToBlob(imgBase64);
    },
    save() {
      this.$refs.form.validate().then(async success => {
        if (!success || this.loading) {
          return false;
        }
        this.loading = true;
        const saveDesImage = await this.createImage();
        const options = {
          embossing_label: this.$route.query.embossing || '',
          engraving_label: this.$route.query.e1 || '',
          engraving_font: this.$route.query.f1 ? this.fonts[Number(this.$route.query.f1)] : '',
          package_type: this.$route.query.bc ? this.info.package.types.find(item => item.name === this.$route.query.bc).id : null,
          package_label: this.$route.query.bt || ''
        }
        if (this.info.package?.id) {
          options.package_id = this.info.package.id;
        }
        const formData = new FormData();
        formData.append('email', this.email);
        formData.append('link', window.location.href);
        formData.append('image', saveDesImage);
        formData.append('options', JSON.stringify(options));
        this.$axios.post('/products/link-to-email', formData)
          .then(res => {
            fbq('track', 'Lead');
            this.emailSuccess = this.$t('youHaveGotMail');
            setTimeout(() => {
              this.saveModalClose();
            }, 2000);
          })
          .catch(err => {
            const temp = {};
            err.response.data.errors.forEach(item => {
              if (item.code === 400) {
                temp[item.property] = [item.message]
              }
            })
            this.$refs.form.setErrors(temp);
          })
          .then(() => {
            this.loading = false;
          })
      })
    },
    // updateCanvas() {
    //   const drawTextAlongArc = (context, str, centerX, centerY, radius, angle, start, invert, fs, direction) => {
    //     if (!str) return
    //     if (str.length % 2 === 0) {
    //       str = str + " ";
    //     }
    //     let len = str.length, s;
    //     context.font = `${fs ? fs : '10'}px ${this.fonts[this.engraving.f]}`;
    //     context.textAlign = 'center';
    //     context.save();
    //
    //     if (direction === 'horizontal') {
    //       context.fillText(str, centerX, centerY);
    //       return;
    //     }
    //
    //     context.translate(centerX, centerY);
    //     context.rotate(-1 * start);
    //     context.rotate((invert ? 1 : -1) * (angle * len) / 2);
    //     for (let n = 0; n < len; n++) {
    //       context.rotate((invert ? -1 : 1) * angle);
    //       context.save();
    //       context.translate(0, (invert ? 1 : -1) * radius);
    //       s = str[n];
    //       context.fillText(s, 0, 0);
    //       context.restore();
    //     }
    //     context.restore();
    //   }
    //   const el = this.$el
    //   switch (this.info.vendor_model.toLowerCase()) {
    //     case 'sorguno':
    //       var items0 = document.querySelectorAll('#canvasTextModal')
    //       items0.forEach((canvas0) => {
    //         let context0 = canvas0.getContext('2d');
    //         context0.clearRect(0, 0, canvas0.width, canvas0.height);
    //         let centerX0 = (canvas0.width / 2) + 10,
    //           centerY0 = (canvas0.height) + 66,
    //           angle0 = 0.024,
    //           radius0 = 360,
    //           start0 = 0.08
    //
    //         drawTextAlongArc(context0, this.engraving.e, centerX0, centerY0, radius0, angle0, start0);
    //       })
    //
    //       break;
    //     case 'sorgunocabo':
    //       var items0 = document.querySelectorAll('#canvasTextModal')
    //       items0.forEach((canvas0) => {
    //         let context0 = canvas0.getContext('2d');
    //         context0.clearRect(0, 0, canvas0.width, canvas0.height);
    //         let centerX0 = (canvas0.width / 2) + 10,
    //           centerY0 = (canvas0.height) + 66,
    //           angle0 = 0.024,
    //           radius0 = 360,
    //           start0 = 0.08
    //
    //         drawTextAlongArc(context0, this.engraving.e, centerX0, centerY0, radius0, angle0, start0);
    //       })
    //
    //       break;
    //     case 'sorgcabo':
    //       var items0 = document.querySelectorAll('#canvasTextModal')
    //       items0.forEach((canvas0) => {
    //         let context0 = canvas0.getContext('2d');
    //         context0.clearRect(0, 0, canvas0.width, canvas0.height);
    //         var centerX0 = (canvas0.width / 2) + 0,
    //           centerY0 = (canvas0.height) - 36,
    //           angle0 = 0.031,
    //           radius0 = 270,
    //           start0 = 0.0
    //
    //         drawTextAlongArc(context0, this.engraving.e, centerX0, centerY0, radius0, angle0, start0);
    //       })
    //
    //       break;
    //     case 'sorgcore':
    //       var items0 = el.querySelectorAll('#canvasTextModal')
    //       items0.forEach((canvas0) => {
    //         let context0 = canvas0.getContext('2d');
    //         context0.clearRect(0, 0, canvas0.width, canvas0.height);
    //         var centerX0 = (canvas0.width / 2) + 0,
    //           centerY0 = (canvas0.height) + 516,
    //           angle0 = 0.011,
    //           radius0 = 800,
    //           start0 = 0.0
    //
    //         drawTextAlongArc(context0, this.engraving.e, centerX0, centerY0, radius0, angle0, start0, false);
    //       })
    //
    //       break;
    //     case 'sorgduo':
    //       var items0 = document.querySelectorAll('#canvasTextModal')
    //       items0.forEach((canvas0) => {
    //         let context0 = canvas0.getContext('2d');
    //         context0.clearRect(0, 0, canvas0.width, canvas0.height);
    //         let centerX0 = (canvas0.width / 2) - 0,
    //           centerY0 = (canvas0.height) - 34,
    //           angle0 = 0.031,
    //           radius0 = 270,
    //           start0 = 0.0
    //
    //         drawTextAlongArc(context0, this.engraving.e, centerX0, centerY0, radius0, angle0, start0);
    //       })
    //
    //       break;
    //     case 'sorgmst':
    //       var items0 = document.querySelectorAll('#canvasTextModal')
    //       items0.forEach((canvas0) => {
    //         let context0 = canvas0.getContext('2d');
    //         context0.clearRect(0, 0, canvas0.width, canvas0.height);
    //         let centerX0 = (canvas0.width / 2) - 0,
    //           centerY0 = (canvas0.height) - 18,
    //           angle0 = 0.031,
    //           radius0 = 270,
    //           start0 = 0.0
    //
    //         drawTextAlongArc(context0, this.engraving.e, centerX0, centerY0, radius0, angle0, start0);
    //       })
    //
    //       break;
    //     case 'sorgbrand':
    //       var items0 = document.querySelectorAll('#canvasTextModal')
    //       items0.forEach((canvas0) => {
    //         let context0 = canvas0.getContext('2d');
    //         context0.clearRect(0, 0, canvas0.width, canvas0.height);
    //         let centerX0 = (canvas0.width / 2) - 0,
    //           centerY0 = (canvas0.height) - 32,
    //           angle0 = 0.031,
    //           radius0 = 270,
    //           start0 = 0.0
    //
    //         drawTextAlongArc(context0, this.engraving.e, centerX0, centerY0, radius0, angle0, start0);
    //       })
    //
    //       break;
    //     case 'sobrcabo':
    //       var items0 = el.querySelectorAll('#canvasTextModal')
    //       items0.forEach((canvas0) => {
    //         let context0 = canvas0.getContext('2d');
    //         context0.clearRect(0, 0, canvas0.width, canvas0.height);
    //         var centerX0 = (canvas0.width / 2) + 0,
    //           centerY0 = (canvas0.height) + 286,
    //           angle0 = 0.015,
    //           radius0 = 580,
    //           start0 = 0.0
    //
    //         drawTextAlongArc(context0, this.engraving.e, centerX0, centerY0, radius0, angle0, start0);
    //       })
    //
    //       break;
    //     case 'sobrduo':
    //       var items0 = el.querySelectorAll('#canvasTextModal')
    //       items0.forEach((canvas0) => {
    //         let context0 = canvas0.getContext('2d');
    //         context0.clearRect(0, 0, canvas0.width, canvas0.height);
    //         var centerX0 = (canvas0.width / 2) + 0,
    //           centerY0 = (canvas0.height) + 286,
    //           angle0 = 0.015,
    //           radius0 = 580,
    //           start0 = 0.0
    //
    //         drawTextAlongArc(context0, this.engraving.e, centerX0, centerY0, radius0, angle0, start0);
    //       })
    //
    //       break;
    //     case 'orbring':
    //       var items0 = el.querySelectorAll('#canvasTextModal')
    //       items0.forEach((canvas0) => {
    //         let context0 = canvas0.getContext('2d');
    //         context0.clearRect(0, 0, canvas0.width, canvas0.height);
    //         let centerX0 = (canvas0.width / 2) + 30,
    //             centerY0 = (canvas0.height) + 95,
    //             angle0 = 0.022,
    //             radius0 = 390,
    //             start0 = 0.08
    //
    //         drawTextAlongArc(context0, this.engraving.e, centerX0, centerY0, radius0, angle0, start0);
    //       })
    //
    //       break;
    //     case 'pavedomeband':
    //       var items0 = el.querySelectorAll('#canvasTextModal')
    //       items0.forEach((canvas0) => {
    //         let context0 = canvas0.getContext('2d');
    //         context0.clearRect(0, 0, canvas0.width, canvas0.height);
    //         let centerX0 = (canvas0.width / 2) ,
    //             centerY0 = (canvas0.height) + 65,
    //             angle0 = 0.024,
    //             radius0 = 350,
    //             start0 = 0
    //
    //         drawTextAlongArc(context0, this.engraving.e, centerX0, centerY0, radius0, angle0, start0);
    //       })
    //
    //       break;
    //     case 'thinpavedomeband':
    //       var items0 = el.querySelectorAll('#canvasTextModal')
    //       items0.forEach((canvas0) => {
    //         let context0 = canvas0.getContext('2d');
    //         context0.clearRect(0, 0, canvas0.width, canvas0.height);
    //         let centerX0 = (canvas0.width / 2) ,
    //             centerY0 = (canvas0.height) + 70,
    //             angle0 = 0.022,
    //             radius0 = 350,
    //             start0 = 0
    //
    //         drawTextAlongArc(context0, this.engraving.e, centerX0, centerY0, radius0, angle0, start0);
    //       })
    //
    //       break;
    //     case 'columnring':
    //       var items0 = el.querySelectorAll('#canvasTextModal')
    //       items0.forEach((canvas0) => {
    //         let context0 = canvas0.getContext('2d');
    //         context0.clearRect(0, 0, canvas0.width, canvas0.height);
    //         let centerX0 = (canvas0.width / 2) ,
    //             centerY0 = (canvas0.height) + 49,
    //             angle0 = 0.02,
    //             radius0 = 350,
    //             start0 = 0
    //
    //         drawTextAlongArc(context0, this.engraving.e, centerX0, centerY0, radius0, angle0, start0);
    //       })
    //
    //       break;
    //     case 'sobrmst':
    //       var items0 = el.querySelectorAll('#canvasTextModal')
    //       items0.forEach((canvas0) => {
    //         let context0 = canvas0.getContext('2d');
    //         context0.clearRect(0, 0, canvas0.width, canvas0.height);
    //         var centerX0 = (canvas0.width / 2) + 0,
    //           centerY0 = (canvas0.height) + 286,
    //           angle0 = 0.015,
    //           radius0 = 580,
    //           start0 = 0.0
    //
    //         drawTextAlongArc(context0, this.engraving.e, centerX0, centerY0, radius0, angle0, start0);
    //       })
    //
    //       break;
    //
    //     case 'sonlsgchn':
    //       var items0 = document.querySelectorAll('#canvasTextModal')
    //       items0.forEach((canvas0) => {
    //         let context0 = canvas0.getContext('2d');
    //         context0.clearRect(0, 0, canvas0.width, canvas0.height);
    //         let centerX0 = (canvas0.width / 2) - 3,
    //           centerY0 = (canvas0.height) - 74,
    //           angle0 = 0,
    //           radius0 = 0,
    //           start0 = 0
    //
    //         drawTextAlongArc(context0, this.engraving.e, centerX0, centerY0, radius0, angle0, start0, false, 8, 'horizontal');
    //       })
    //
    //       break;
    //   }
    //
    //
    // },
    saveModalClose() {
      this.saveModal = false;
      this.email = null;
      this.emailSuccess = false;
      this.$refs.form.reset();
      this.$emit('close');
    },
  },
  // computed: {},
  watch: {
    drawer: {
      immediate: true,
      handler(val) {
        if (val) {
          this.createProductImg();
          // this.$nextTick(() => {
          //   this.products = this.info.request_config || [];
          //   this.updateCanvas();
          //   if (this.info.theme.id === this.constProductThemes().package && this.info.vendor_model.toLowerCase() === 'sobxsjb') {
          //     this.setBoxText();
          //   }
          // })
        }
      }
    }
  },
  mounted() {
    // this.updateCanvas();
    // if (this.info.theme.id === this.constProductThemes().package && this.info.vendor_model.toLowerCase() === 'sobxsjb') {
    //   this.setBoxText();
    // }
  }
}
